import { useRecoilCallback } from 'recoil';
import { imagePopupState } from '../store/state';

export const useClosePopup = () => {
  return useRecoilCallback(
    ({ set }) => (namespace: ImageV3State.PopupType) => {
      set(imagePopupState(namespace), v => ({ ...v, visible: false }));
    },
    []
  );
};
